import { createInstance } from 'i18next';
import { initReactI18next } from 'react-i18next';
import config from '../../config/config';
import { LanguageCode } from '@communication-center/data-objects';
import en from './locales/en/translation.json';
import ja from './locales/ja/translation.json';

const i18nInstance = createInstance();

i18nInstance.use(initReactI18next)
    .init({
        lng: LanguageCode.EN,
        fallbackLng: LanguageCode.EN,
        debug: config.debugMode,
        cleanCode: true,
        returnEmptyString: false,
        interpolation: {
            escapeValue: false
        },
        resources: {
            en: { translation: en },
            ja: { translation: ja }
        }
    });

export default i18nInstance;
